import React from 'react';
import { Popover } from '@mui/material';
import { useColumnHeaderContext } from '../hooks/useColumnHeaderContext';
import { ColumnHeaderButton } from './ColumnHeaderButton';
import { ColumnHeaderMenu } from './ColumnHeaderMenu';

interface ColumnHeaderProps {
  customHeader?: React.ReactNode;
  icon?: React.ReactNode;
  emptyStateMessage?: string;
}

export const ColumnHeader: React.FC<ColumnHeaderProps> = ({ customHeader, icon, emptyStateMessage }) => {
  const { popover } = useColumnHeaderContext();

  return (
    <>
      <ColumnHeaderButton customHeader={customHeader} icon={icon} />

      <Popover
        open={popover.isOpen}
        anchorEl={popover.anchorEl}
        onClose={popover.onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: 345,
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          },
        }}
      >
        <ColumnHeaderMenu emptyStateMessage={emptyStateMessage} />
      </Popover>
    </>
  );
};
